import {assert} from 'Asserts';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {SampleDetails} from 'constants/SampleConstants';
import {BatchInfo, BioentityInfo} from 'folder-items/FileConstants';
import makeEmptySampleDetails from 'notebook/sample-propagation/util/makeEmptySampleDetails';
import APIUtil from 'util/APIUtil';
import {ExternalInputSpecifierType} from 'workflows/stage-entries/components/ExternalInputPicker';

export default function convertInputSpecifierToSamples(
  inputSpecifier: ExternalInputSpecifierType
): Array<SampleDetails> {
  const samples: Array<SampleDetails> = [];
  if (inputSpecifier.bioentityInfo) {
    samples.push({
      ...makeEmptySampleDetails(),
      bioentityInfo: inputSpecifier.bioentityInfo,
    });
  } else if (inputSpecifier.batchInfo) {
    samples.push({
      ...makeEmptySampleDetails(),
      batchInfo: inputSpecifier.batchInfo,
    });
  } else if (inputSpecifier.containerInfo && inputSpecifier.containedItemsForContainer) {
    for (const containedItem of inputSpecifier.containedItemsForContainer) {
      if (containedItem.id != null && APIUtil.isBiologicalEntity(containedItem.id)) {
        samples.push({
          ...makeEmptySampleDetails(),
          bioentityInfo: containedItem as BioentityInfo,
          containerInfo: inputSpecifier.containerInfo,
        });
      } else {
        assert(
          containedItem.id != null && APIUtil.apiIdToType(containedItem.id) === ModelTypeConstants.BATCH,
          'Expected batch'
        );
        samples.push({
          ...makeEmptySampleDetails(),
          batchInfo: containedItem as BatchInfo,
          containerInfo: inputSpecifier.containerInfo,
        });
      }
    }
  }

  return samples;
}
